import { css } from "styled-components";

import { greyMui } from "../declarations";
import { rydeColors } from "../parts";

export const scrollbarStyles = css`
  .thin_scrollbar {
    &::-webkit-scrollbar {
      width: 8px;
      height: 15px;
    }
    &::-webkit-scrollbar-track {
      background-color: ${rydeColors.smoke};
    }
    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${greyMui._600};
    }
    @supports (-moz-appearance: none) {
      scrollbar-width: thin;
    }
  }

  .middle_scrollbar {
    &::-webkit-scrollbar {
      width: 14px;
      height: 15px;
    }
    &::-webkit-scrollbar-track {
      background-color: ${rydeColors.smoke};
    }
    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${greyMui._600};
    }
    @supports (-moz-appearance: none) {
      scrollbar-width: thin;
    }
  }
`;
